









































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { getCurrentCompanyId, getCurrentUserId } from "@/plugins/roles";
import { NotificationsListParams, list } from "@/getinfo-api/notifications";
import { Notification as INotification } from "@/api-v2/notification/models/notification";
import UserNotificationListItem from "@/components/notification/UserNotificationListItem.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, UserNotificationListItem, CBlock, CField, CPage }
})
export default class UserNotificationList extends Vue {
  notifications: INotification[] = [];
  count: number = 0;
  isLoading: boolean = false;
  searchParams: NotificationsListParams = {
    companyId: this.companyId ?? undefined,
    userId: this.userId,
    read: undefined,
    sort: "createdAt",
    order: "DESC",
    limit: 30,
    offset: 0
  };

  get userId() {
    return getCurrentUserId();
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  get notResult() {
    return !this.isLoading && this.notifications?.length === 0;
  }

  get isShowMoreButtonVisible() {
    return this.notifications?.length < this.count;
  }

  updateNotification(notification: INotification) {
    const notificationIndexForChanges = this.notifications?.findIndex(
      el => el.id === notification.id
    );

    this.notifications[notificationIndexForChanges].read = true;
    this.notifications[notificationIndexForChanges].readAt =
      notification.readAt;
  }

  showMore() {
    this.searchParams.offset! += this.searchParams.limit!;
    this.getNotifications();
  }

  clearFilter() {
    this.searchParams.offset = 0;
    this.searchParams.read = undefined;
    this.notifications = [];
    this.count = 0;
    this.getNotifications();
  }

  applyFilter() {
    this.searchParams.offset = 0;
    this.notifications = [];
    this.count = 0;
    this.getNotifications();
  }

  async getNotifications() {
    try {
      this.isLoading = true;
      const { data } = await list(this.searchParams);
      this.notifications = [...this.notifications, ...data.items];
      this.count = data.count;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getNotifications();
  }
}
